import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { save, load } from "redux-localstorage-simple";
import { composeWithDevTools } from "@redux-devtools/extension";
import rootReducer from "./reducers/rootReducer";

export const store = createStore(rootReducer, load(), composeWithDevTools(applyMiddleware(thunk, save())));

// Site-scoped data (site info, root page, brand, dynamic page paths) is NOT fetched here:
// which site is current depends on the URL (/shops/<name> vs the legacy APP_BASE), so
// BaseLayout dispatches those fetches per base change. Fetching a fixed base at store
// creation was the one assumption that limited the app to a single storefront.
